module.exports = __webpack_public_path__ + "static/media/metricpopup_logo_socialsharingsite.a45ccead.png";